export const addInitialValues = {
  activityName: '',
  area: '',
  isProductive: true,
};
